import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const topCategories = categories.filter((_, i) => [0, 2, 10, 9].includes(i));

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <h3 className="text-white text-2xl md:text-3xl font-heading font-light mb-4">Stay in the Loop</h3>
            <p className="text-foreground-300 text-sm leading-relaxed mb-8 max-w-[380px]">
              Get the latest mulebuy spreadsheet insights, comparison updates, and curated buying guides delivered straight to your inbox.
            </p>

            <form
              data-readdy-form
              id="newsletter-form"
              action="https://readdy.ai/api/form/d8sl575e8ise6dlc8tp0"
              method="POST"
              className="max-w-[380px]"
            >
              <div className="mb-4">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Your email address"
                  className="w-full bg-transparent border-0 border-b border-foreground-600 py-3 text-background-50 text-sm placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
                />
              </div>
              <button
                type="submit"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-950 text-sm font-semibold cursor-pointer hover:bg-white transition-all whitespace-nowrap"
              >
                Subscribe
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white text-sm font-semibold mb-5">Top Categories</h4>
            <ul className="space-y-3">
              {topCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline underline-offset-4"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/"
                  className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline underline-offset-4"
                >
                  Home
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-white text-sm font-semibold mb-5">Contact</h4>
            <div className="space-y-3 mb-8">
              <p className="text-foreground-400 text-sm">support@mulebuyspreadsheets.cyou</p>
            </div>

            <h4 className="text-white text-sm font-semibold mb-5">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/mulebuy-spreadsheet-complete-guide"
                  className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline underline-offset-4"
                >
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline underline-offset-4"
                >
                  Comparison Hub
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer underline underline-offset-4"
                >
                  Main Platform
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <span className="text-foreground-400 text-sm">Instagram</span>
            <span className="text-foreground-400 text-sm">X (Twitter)</span>
            <span className="text-foreground-400 text-sm">Pinterest</span>
          </div>
          <p className="text-foreground-500 text-xs">&copy; 2026 Mulebuy Spreadsheets. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/" className="text-foreground-400 text-xs hover:text-white transition-colors cursor-pointer underline underline-offset-4">Home</Link>
            <Link to="/mulebuy-spreadsheet-complete-guide" className="text-foreground-400 text-xs hover:text-white transition-colors cursor-pointer underline underline-offset-4">Guide</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}